import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pink-rider-banner',
  template: require('./pink-rider-banner.component.html'),
  styles: [`
    .pink-rider-banner {
      background-color: #fff4ce;
      border: 1px solid #f1d176;
      border-radius: 4px;
      padding: 12px 16px;
      margin-bottom: 16px;
      color: #222;
      display: flex;
      align-items: flex-start;
      gap: 8px;
    }
    .pink-rider-banner-icon {
      color: #2e7d32;
      font-size: 20px;
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      margin-top: 2px;
    }
    .pink-rider-banner-lines {
      flex: 1;
      min-width: 0;
    }
    .pink-rider-banner-line {
      font-size: 14px;
      line-height: 1.5;
    }
    .pink-rider-banner-line + .pink-rider-banner-line {
      margin-top: 4px;
    }
    .pink-rider-banner-line-head {
      font-weight: 700;
      letter-spacing: 0.2px;
    }
  `]
})
export class PinkRiderBannerComponent {
  @Input() header = '';
  @Input() femaleEligibleMessage = '';
  @Input() maleOthersEligibleMessage = '';
}
